export { WarehouseService } from './service.es.js';
